import { render, staticRenderFns } from "./ATextArea.vue?vue&type=template&id=7f807af0&"
import script from "./ATextArea.vue?vue&type=script&lang=js&"
export * from "./ATextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports